const BarRankTypes = {
    FETCH_START:    '[BAR][RANK] FETCH START',
    FETCH_SUCCESS:  '[BAR][RANK] FETCH SUCCESS',
    FETCH_FAILURE:  '[BAR][RANK] FETCH FAILURE'
};

export default BarRankTypes;